import { render, staticRenderFns } from "./totalEnergyConsumption.vue?vue&type=template&id=51a7d37a&scoped=true&"
import script from "./totalEnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./totalEnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./totalEnergyConsumption.vue?vue&type=style&index=0&id=51a7d37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a7d37a",
  null
  
)

export default component.exports